import { render, staticRenderFns } from "./AnaliseProdutoTableFatMesClassificacao.vue?vue&type=template&id=0132d8c0&scoped=true&"
import script from "./AnaliseProdutoTableFatMesClassificacao.vue?vue&type=script&lang=js&"
export * from "./AnaliseProdutoTableFatMesClassificacao.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseProdutoTableFatMesClassificacao.vue?vue&type=style&index=0&id=0132d8c0&scoped=true&lang=css&"
import style1 from "./AnaliseProdutoTableFatMesClassificacao.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0132d8c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
